export const SUPPORTED_LOCALES = [
  'en-GB',
  'nl-NL',
  'fr-FR',
  'it-IT',
  'es-ES',
  'de-DE',
  'pl-PL',
  'pt-PT',
  'ar-AE',
  'ur-PK',
  'sv-SE',
  'fi-FI',
  'bg-BG',
  'da-DK',
  'ru-RU',
  'el-GR',
  'zh-Hans-CN',
  'sq-AL',
  'hr-HR',
  'hu-HU',
  'ro-RO',
  'sl-SI',
  'sk-SK',
  'cs-CZ',
  'tr-TR',
  'no-NO',
  'hi-IN',
  'ja-JP',
  'zh-Hant-CN',
  'ko-KR',
  'vi-VN',
  'uk-UA',
] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en-GB';
